<script setup lang="ts">
  import { computed } from 'vue';
  import type { InfoListItemProps } from '../InfoList/InfoListItem';
  import {
    statusPanelClass,
    statusPanelContentClass,
    statusPanelDataItemValueClass,
    statusPanelDataItemWrapperClass,
    statusPanelDataListClass,
    statusPanelTitleClass,
    statusPanelVariants,
    statusPanelDataItemLabelClass,
  } from './StatusPanel.css';
  import type { StatusPanelVariant } from './StatusPanel.types';

  export type StatusPanelProps = {
    id?: string;
    testId?: string;
    title?: string;
    fullWidth?: boolean;
    variant: StatusPanelVariant;
    data: InfoListItemProps[];
  };

  const props = defineProps<StatusPanelProps>();

  const statusPanelClasses = computed(() => [
    statusPanelClass,
    statusPanelVariants[props.variant],
  ]);
</script>

<template>
  <div :class="statusPanelClasses">
    <div :class="statusPanelContentClass">
      <div :class="statusPanelTitleClass[variant]">{{ title }}</div>
      <div :class="statusPanelDataListClass">
        <div
          v-for="item in data"
          :key="item.label"
          :class="statusPanelDataItemWrapperClass"
        >
          <p :class="statusPanelDataItemLabelClass">{{ item.label }}</p>
          <p :class="statusPanelDataItemValueClass">{{ item.value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
